import React from 'react';
import { DialogActions, DialogContent } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { colors } from '@skyslope/mache';
import { useIsSmallScreenMediaQuery } from '../../../lib/isSmallScreen';

const useStyles = makeStyles(() => ({
  modal: {
    height: '230px',
    width: '600px',
  },
  closeButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '40px',
  },
  icon: {
    color: colors.grey[500],
    position: 'absolute',
    top: '6px',
    right: '6px',
  },
  modalTitle: {
    display: 'flex',
    justifyCntent: 'flex-start',
    color: colors.grey[900],
    padding: '0px 0px 24px 0px',
  },
  body: {
    padding: '0px 40px 0px 40px',
  },
  subject: {
    fontSize: '22px',
  },
  buttonWrapper: {
    position: 'absolute',
    bottom: '0',
    display: 'flex',
    justifyContent: 'flex-end',
    boxSizing: 'border-box',
    padding: '15px',
    borderTop: `1px solid ${colors.grey[400]}`,
    width: '100%',
  },
  stayButton: {
    marginRight: '12px',
    paddingLeft: '24px',
    paddingRight: '24px',
    '&:hover': {
      backgroundColor: colors.blue[50],
    },
  },
  leaveButton: {
    '&:hover': {
      backgroundColor: colors.blue[600],
    },
  },
}));

interface SureYouWantToLeaveDialogProps {
  close: () => void;
  confirmBack: () => void;
}

export function SureYouWantToLeaveDialog(props: SureYouWantToLeaveDialogProps) {
  const { close, confirmBack } = props;
  const classes = useStyles();
  const isSmallScreen = useIsSmallScreenMediaQuery();

  return (
    <Dialog
      open
      onClose={close}
      classes={{ paper: isSmallScreen ? '' : classes.modal }}
      maxWidth="lg"
      fullWidth
      fullScreen={isSmallScreen}
      BackdropProps={{ style: { backgroundColor: colors.grey[800], opacity: 0.6 } }}
    >
      <div className={classes.closeButton}>
        <IconButton data-spec="closeFromsLeaveWarning" classes={{ root: classes.icon }} onClick={props.close}>
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent>
        <div className={classes.body}>
          <div className={classes.modalTitle}>
            <Typography variant="h3">Are you sure you want to leave?</Typography>
          </div>
          <Typography>Changes you have entered will not be saved.</Typography>
        </div>
      </DialogContent>

      <DialogActions>
        <Button data-spec="stayButton" variant="text" color="primary" className={classes.stayButton} onClick={close}>
          Stay
        </Button>
        <Button
          data-spec="leaveButton"
          variant="contained"
          color="primary"
          className={classes.leaveButton}
          onClick={confirmBack}
        >
          Leave
        </Button>
      </DialogActions>
    </Dialog>
  );
}
